import { z } from 'zod';

export const PublicProfileSchema = z.object({
    id: z.string(),
    is_anonymous: z.boolean().default(false),
    username: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    preferred_name: z.string(),
    profile_photo: z.string(),
    cover_photo: z.string(),
    bio: z.string(),
    show_tour: z.boolean(),
    is_logged_in: z.boolean(),
    npub: z.string().optional(),
});

export const UserProfileSchema = PublicProfileSchema.extend({
    email: z.string(),
    phone_number: z.string(),
    provider: z.string(),
    additional_info: z.union([z.string(), z.record(z.any())]),
    show_tour: z.boolean(),
});

export type PublicProfile = z.infer<typeof PublicProfileSchema>;
export type UserProfile = z.infer<typeof UserProfileSchema>;
export const EmptyUserProfile: UserProfile = {
    id: '',
    is_anonymous: true,
    username: 'Anonymous',
    email: '',
    first_name: '',
    last_name: '',
    preferred_name: '',
    profile_photo: '',
    cover_photo: '',
    phone_number: '',
    provider: '',
    bio: '',
    additional_info: {},
    show_tour: true,
    is_logged_in: false,
};
